import { PositionHedgeAdded, PositionHedgeUpdated } from "./longShort.actions";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import { PositionHedge } from "./positionHedge";

export class PositionHedgeReducer extends ReducerBase<PositionHedge[]> {
  constructor() {
    super();
    this.addHandler(PositionHedgeAdded.EventName, this.handlePositionHedgeAdded);
    this.addHandler(PositionHedgeUpdated.EventName, this.handlePositionHedgeUpdated);
  }

  handlePositionHedgeAdded(
    state: PositionHedge[] = initialState.positionHedges,
    event: PositionHedgeAdded
  ): PositionHedge[] {
    return [...state, { ...event.positionHedge }];
  }

  handlePositionHedgeUpdated(
    state: PositionHedge[] = initialState.positionHedges,
    event: PositionHedgeUpdated
  ): PositionHedge[] {
    return state.map(t => (t.id === event.positionHedge.id ? event.positionHedge : t))
  }

  handleDefault(state: PositionHedge[] = initialState.positionHedges) {
    return state;
  }
}